import { isApplePayAvailableAsPaymentMethod as isApplePayAvailableAsPaymentMethodFromOrder } from '../selectors/order';
import { CheckoutState } from '../state';
import { isEventbriteTLDInDevOrQAEnv, isIosWebView } from '../utils/browser';
import { isEventbriteTLD, isIosApp } from './app';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    areSyncExpressCheckoutEligibleCommonRulesMet,
    isApplePayAvailableAsPaymentMethod,
} from './expressCheckout';

export const isTLDWithApplePayEnabled = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv() || isIosApp(state);

export const isApplePayInCheckoutStepEnabled = (state: CheckoutState) =>
    isApplePayAvailableAsPaymentMethodFromOrder(state) &&
    isTLDWithApplePayEnabled(state) &&
    getIsApplePaySupported(state);

export const getCanMakePaymentsWithActiveCard = (state: CheckoutState) =>
    state.applepay?.canMakePaymentsWithActiveCard;

export const isApplePaySortedAndPreselected = (state: CheckoutState) =>
    !!getCanMakePaymentsWithActiveCard(state);

export const getApplePayInstance = (state: CheckoutState) =>
    state.applepay?.applepayInstance;

export const hasApplePayAsyncErrors = (state: CheckoutState) =>
    state.applepay?.hasAsyncErrors;

export const getIsLoadingApplePay = (state: CheckoutState) =>
    state.applepay?.isLoadingApplePay;

export const getIsApplePaySupported = (state: CheckoutState) =>
    state.applepay?.isApplePaySupported;

export const isApplePayInstanceCreated = (state: CheckoutState) =>
    !!getApplePayInstance(state);

export const areSyncExpressApplePayEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isIosWebView() &&
    isTLDWithApplePayEnabled(state) &&
    getIsApplePaySupported(state);

export const areAsyncExpressApplePayEligibleRulesMet = (state: CheckoutState) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isApplePayAvailableAsPaymentMethod(state) &&
    !hasApplePayAsyncErrors(state);

export const getApplePay = (state: CheckoutState) => state.applepay;

export const isExpressApplePayEnabled = (state: CheckoutState) =>
    areSyncExpressApplePayEligibleRulesMet(state) &&
    areAsyncExpressApplePayEligibleRulesMet(state);
